<div class="dropdown-container" appClickOutside (clickOutside)="close()">
  <ng-content></ng-content>
</div>
